import React, { useEffect } from 'react'
import '../styles/TargetKlein.css'
import { useState } from 'react';

function TargetKlein(props) {

    var TargetText = props.TargetText;
    var Type = props.TargetType;
    var theTheme = props.Theme;
    const [TargetType, setTargetType] = useState("");
    const [WorldTheme, setWorldTheme] = useState('Default');
    const [Glas, setGlas] = useState('LupeKleinGlasDefault');
    const [Stiel, setStiel] = useState('LupeKleinStielDefault')

    useEffect(()=> {
      if(theTheme == "SecretDucks"){
          setWorldTheme('SecretDucks'); 
          setGlas('LupeKleinGlasSD');  
          setStiel('LupeKleinStielSD');       
      }
      if(theTheme == "Default"){
          setWorldTheme('Default');
          setGlas('LupeKleinGlasDefault');  
          setStiel('LupeKleinStielDefault'); 
      }
  })

    useEffect(() => {
      if(Type=="1"){setTargetType("TargetTypeKlein1");}
      if(Type=="2"){setTargetType("TargetTypeKlein2");}
      if(Type =="3"){
        setTargetType('TargetType3');
        if(TargetText=="img001")
        {
          setTargetType('TargetTypeKlein3 Maus');
        }
        if(TargetText=="Nase")
        {
          setTargetType('TargetTypeKlein3 Nase');
        }
        if(TargetText=="Boden")
        {
          setTargetType('TargetTypeKlein3 Boden');
        }
        if(TargetText=="denke")
        {
          setTargetType('TargetTypeKlein3 Denken');
        }
        if(TargetText=="findet")
        {
          setTargetType('TargetTypeKlein3 Finden');
        }
        if(TargetText=="Entenerpel")
        {
          setTargetType('TargetTypeKlein3 Entenerpel');
        }
        if(TargetText=="Feigenkerne")
        {
          setTargetType('TargetTypeKlein3 Feigenkerne');
        }
        if(TargetText=="verbogen")
        {
          setTargetType('TargetTypeKlein3 Verbogen');
        }
        if(TargetText=="geliket")
        {
          setTargetType('TargetTypeKlein3 Gelikt');
        }
        if(TargetText=="Besen")
        {
          setTargetType('TargetTypeKlein3 Besen');
        }
        if(TargetText=="Farbe")
        {
          setTargetType('TargetTypeKlein3 Farbe');
        }
        if(TargetText=="fege")
        {
          setTargetType('TargetTypeKlein3 fege');
        }
        if(TargetText=="badet")
        {
          setTargetType('TargetTypeKlein3 badet');
        }
        if(TargetText=="Pudelbeine")
        {
          setTargetType('TargetTypeKlein3 Pudelbeine');
        }
        if(TargetText=="Notenhefte")
        {
          setTargetType('TargetTypeKlein3 Notenhefte');
        }
        if(TargetText=="gelogen")
        {
          setTargetType('TargetTypeKlein3 gelogen');
        }
        if(TargetText=="downloaden")
        {
          setTargetType('TargetTypeKlein3 downloaden');
        }

    }
    })


  return (
    <div className='TargetKleinWrapper'>
        <div className={Glas}>
            <div className={TargetType}>{TargetText}</div>
        </div>
        <div className={Stiel}></div>
    </div>
  )
}

export default TargetKlein